import _ from 'underscore';

export default class WebSources {
  constructor($scope, $rootScope, WebSourceService, PaginationService) {
    $scope.load_data = function() {
      $scope.loading = true;


      console.log($scope.filter);
      WebSourceService.get($scope.filter).success(function(data) {
        $scope.sources = data.sources;
        $scope.pagination = PaginationService.get_pagination(data.pagination);
        if ($scope.selected_sources) {
          _.each($scope.selected_sources, function(source_id) {
            var source = _.findWhere($scope.sources, {
              id: source_id
            });
            if (source)
              source.checked = true;
          });
        }
        $scope.loading = false;
      });
    };

    $scope.check_sources = function() {
      _.each($scope.sources, function(c) {
        c.checked = $scope.select_all;
      });
    };
    
    $scope.init_filter = function() {
      $scope.filter = {
        page: 1,
        per_page: 40
      };
    };

    $scope.get_page_data = function(page) {
      $scope.filter.page = page;
      $scope.load_data();
    };

    $scope.quick_search = function() {
      window.filter_table('table.data', $scope.quick_filter);
    };

    $scope.delete_sources = function() {
      var sources = _.where($scope.sources, {
        checked: true
      });
      if (sources.length === 0) {
        alert('Please select at least one source!');
        return;
      }
      
      if (confirm('Are you sure you want to delete these sources?')) {
        sources = _.pluck(sources , 'id');
        WebSourceService.delete_sources(sources).then(function(data) {
          if (data.success) {
            $scope.sources = _.filter($scope.sources, (v) => _.indexOf(sources, v.id) === -1);
          }
        });
      }
    };
    
    
    $scope.init = function() {
      $scope.sources = [];
      $scope.pagination = {};
      $scope.init_filter();
      $scope.load_data();
    };

    $scope.init();

  }
}

WebSources.$inject = ['$scope', '$rootScope', 'WebSourceService', 'PaginationService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/web-sources.ctrl.js